import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AutomationsIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "4.3329",
                y: "6.55556",
                width: "11.3333",
                height: "9.55556",
                rx: "1.22222",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.333 9.55542H16.2219C17.2037 9.55542 17.9997 10.3514 17.9997 11.3332V12.2221C17.9997 13.2039 17.2037 13.9999 16.2219 13.9999H15.333",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.66699 9.55542H3.7781C2.79626 9.55542 2.00032 10.3514 2.00032 11.3332V12.2221C2.00032 13.2039 2.79626 13.9999 3.7781 13.9999H4.66699",
                stroke: color || "#676879",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.2227 10.4443L12.2227 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.77734 10.4443L7.77734 11.7777",
                stroke: color || "#676879",
                strokeWidth: "1.11111",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5556 3.33325C10.5556 3.02643 10.3068 2.7777 10 2.7777C9.69318 2.7777 9.44444 3.02643 9.44444 3.33325L10.5556 3.33325ZM9.44444 3.33325L9.44444 6.88881L10.5556 6.88881L10.5556 3.33325L9.44444 3.33325Z",
                fill: color || "#676879"
            })
        ]
    });
